// initial state
const baseName = '/admin/api/config'

const configGroup = baseName + '/group'
const configUpdate = baseName + '/updateGroup'

const a = Object.assign({configGroup, configUpdate})
export default a
